"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="226017" className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const services = ["Fractional IT Support", "Managed RMM & Security", "Windows Update Management", "O365 Tenant Support"];
  const currentYear = new Date().getFullYear();
  return <section id="smb-it-tech-footer" className="bg-background text-foreground pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-12">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/" className="inline-block w-fit">
              <img src="/img/antares_security_logo_light.png" alt="SMB IT Tech" className="h-7 w-auto" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed font-default pr-4">
              IT for the next unicorn. We provide fractional IT services with flat $110/device pricing, ensuring your startup has the technical foundation to scale without the overhead.
            </p>
          </div>

          {}
          <div>
            <h3 className="text-foreground font-semibold mb-6 font-default uppercase tracking-wider text-xs">Quick Links</h3>
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="text-foreground font-semibold mb-6 font-default uppercase tracking-wider text-xs">Core Services</h3>
            <ul className="space-y-3">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm font-mono">
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="text-foreground font-semibold mb-6 font-default uppercase tracking-wider text-xs">Connect</h3>
            <ul className="space-y-3 text-sm text-muted-foreground font-default">
              <li>
                <Link to="mailto:Nesta@smbittech.com" className="hover:text-primary transition-colors">Nesta@smbittech.com</Link>
              </li>
              <li>Plano, Tx</li>
              <li className="text-primary font-mono text-xs mt-4">EST. 2024</li>
            </ul>
          </div>

        </div>

        {}
        <Separator className="bg-border/20 mb-8" />
        
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground font-default">
          <p className="font-mono text-xs">© {currentYear} SMB IT Tech. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-primary transition-colors font-semibold">
              Built for Startups
            </Link>
          </div>
        </div>
      </div>
    </section>;
}